<template>
  <zen-one 
  :showuserinfo="false" 
  title="Pentadbiran"
  :crumbs="crumbs"
  >

  <div class="mb3"></div>

  <z-page
  title="Tadbir Pengguna"
  >

  <div class="table_scrol">
        <div class="w-card__content content-hardcode">

  <w-dialog
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    width="80%"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      <template v-if="form.id">
      Kemaskini 
      </template>
      <template v-else>
        Tambah  
      </template>
    </template>

    <w-form 
      ref="form" 
      v-model="dialog.valid"
      @validate="submit1"
      @success="success"
    >
      <w-transition-bounce>
        <w-alert
          class="my0 mb2 text-light"
          v-if="$page.props.flash.error"
          error
          transition="bounce"
          plain
          round
          no-border
          dismiss
          >
            {{$page.props.flash.error}}
        </w-alert>
      </w-transition-bounce>
    <!-- <z-input label="Name" v-model="form.name" name="name" :validators="[validators.required]" /> -->
    <!-- <z-input class="mt3" label="Email" v-model="form.email" name="email" :validators="[validators.required]" /> -->
    <div class="grow mb4" style="min-width: 200px">
      <div class="spacer">Jenis Pengguna * :</div>
         <br>
         <w-radios v-model="form.lkp_jenis_pengguna_id" :items="jenis_pengguna"
        :validators="[validators.required]" inline />
   </div>
    <!-- <template v-if="form.id==0">
      <w-select 
        outline
        label="Peranan *"  
        v-model="form.role_id"
        :items="[
          { value: '1', label: 'Pentadbir Sistem' },
          { value: '2', label: 'Penternak' },
          { value: '3', label: 'Al Man' },
        ]"
        :validators="[validators.required]"
        />
        </template> -->
      <div class="spacer"></div>
      <w-flex wrap :gap="2">
        <div class="grow mb4" style="min-width: 200px">
            
          <w-input
            outline
            label="No. Kad Pengenalan *"
            class="mt3"
            type="text"
            placeholder="No. Kad Pengenalan"
            name="no_id"
            v-model="form.no_id"
            :validators="[validators.required]"
          />
          <div class="spacer"></div>
          <br>
          <w-input
                outline
                label="Emel *"
                class="mt3"
                type="email"
                placeholder="Sila Masukkan Emel"
                name="email"
                v-model="form.email"
                :validators="[validators.required, validators.email]"
          />
        </div>
        <div class="grow mb4" style="min-width: 200px ">
          <w-input
            outline
            label="Nama Penuh *"
            class="mt3"
            type="text"
            placeholder="Nama Penuh"
            name="name"
            v-model="form.name"
            :validators="[validators.required]"
          />
          <div class="spacer"></div>
          <br>
          <w-input
              outline
              label="Nombor Telefon *"
              class="mt3"
              type="tel"
              placeholder="Sila Masukkan Nombor Telefon"
              name="no_tel"
              v-model="form.no_tel"
              :validators="[validators.required, validators.numeric]"
          />
        </div>
      </w-flex>
      <div class="spacer"></div>
      <w-textarea 
          outline 
          label="Alamat*"
          placeholder="Sila Masukkan Alamat"
          class="mt3"
          name="alamat"
          v-model="form.alamat"
          type="text-area"
          :validators="[validators.required]"/>
      <div class="spacer"></div>
                <br>
                <template >
                 <w-select 
                    outline
                    :items="poskod" 
                    label="Poskod"  
                    v-model="form.lkp_poskod_id"
                    @input="checkPoskod()"
                    />
                </template>
                  <w-input
                     outline
                     label="Poskod"
                     class="mt3"
                     type="tel"
                     placeholder="Sila Masukkan Poskod"
                     name="poskod"
                     v-model="form.kode"
                     @change="getPoskodUtama()"
                     :validators="[validators.required, validators.numeric]"
                    /><div class="spacer"></div>
                <br>
                <w-select 
                    outline
                    :items="bandar" 
                    label="Bandar *"  
                    v-model="form.lkp_bandar_id"
                    @input="getPoskod(2)"
                    :validators="[validators.required]"/>

                  <div class="spacer"></div>
                <br>
                <w-select 
                    outline
                    :items="negeri" 
                    label="Negeri *"  
                    v-model="form.lkp_negeri_id"
                    @input="getBandar(2);getCawangan(2)"
                    :validators="[validators.required]"/>
      <br>
      <w-select 
        outline
        :items="cawangan" 
        label="Tempat Bertugas"  
        v-model="form.lkp_cawangan_id"
        v-if="form.lkp_jenis_pengguna_id==1"
        />
      <div class="spacer"></div>
      <br>
      <template v-if="form.status == 1">
        <w-switch v-model="form.status" label="Aktif" v-if="form.status == 1"/>
      </template>
      <template v-else>
        <w-switch v-model="form.status" label="Tidak Aktif" />
      </template>
      <div class="spacer"></div>
      <br>
      <w-tooltip right align-bottom color="white" bg-color="blue">
          <template #activator="{ on }">
              <span v-on="on">
                <div class="spacer"></div>
                <w-input
                  outline
                  label="Sila Masukkan Kata Laluan (Kosongkan untuk tidak mengubah password) *"
                  class="mt3"
                  placeholder="Sila Masukkan Kata Laluan"
                  :type="isPassword ? 'password' : 'text'"
                  :inner-icon-right="
                    isPassword ? 'fal fa-eye-slash' : 'fal fa-eye'
                  "
                  @click:inner-icon-right="isPassword = !isPassword"
                  name="password"
                  v-model="form.password"
                />
              </span>
          </template>
        Medan Ini Wajib , minimum 8 aksara
      </w-tooltip>

    </w-form>

    
    <template #actions>
      <div class="spacer" />
      <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">Tutup</w-button>
      <w-button 
      class="ml1" 
      :loading="dialog.loading"
      :disabled="dialog.valid === false"
      @click="$refs.form.validate()"
      >
        Simpan
      </w-button>
    </template>

    
  </w-dialog>
   <div class="w-card__content content-hardcode mb3">
      <w-form v-model="valid" @validate="cari" ref="frm">

         <w-flex class="mt3">
            <div class="xs4">
               <w-input
                  v-model="pencarian.name"
                  label="Nama"
                  />
            </div>
            <div class="xs4">
               <w-input 
                  v-model="pencarian.no_id"
                  label="No Kad Pengenalan/No Pasport"
                  />
            </div>
            <div class="xs4">
               <w-input
                  v-model="pencarian.email"
                  label="E-mel"
                  />
            </div>
         </w-flex>
         <w-flex class="mt3">
            <div class="xs4">
               <z-select
               v-model="pencarian.role_id"
               :items="peran" 
               label="Peranan"
               />
            </div>

            <div class="xs4">
               <z-select
               v-model="pencarian.lkp_negeri_id"
               :items="negeri"
               label="Negeri"
               />
            </div>
            <div class="xs4">
               <z-select
               v-model="pencarian.status"
               :items="[
                 { value: 1, label: 'Aktif' },
                 { value: 2, label: 'Tidak Aktif' },
                 { value: 3, label: 'Tolak' },
                 { value: 4, label: 'Baharu' },
               ]"
               label="Status"
               />
            </div>
         </w-flex>
      </w-form>

      <w-flex justify-end class="mt2">
          <w-button
              class="mr2"
              v-on:click="resetPencarian()"
              bg-color="warning"
              ><w-icon>fal fa-redo</w-icon>&nbsp;RESET
          </w-button>
          <w-button
              class="mr2"
              bg-color="primary"
              @click="$refs.frm.validate()"
              ><w-icon>fal fa-search</w-icon>&nbsp;CARI
          </w-button>
      </w-flex>
   </div>
  <z-table
    ref="tbluser"
    title="Senarai Pengguna"
    :headers="table.headers"
    :items="table.items"
    :meta="table.meta"
    class=""
  >
    <template #button>
         <inertia-link :href="$route('administration.user.form',0)" class="w-button green--bg  w-button--dark size--md  ml1"> 
            <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
         </inertia-link>
    </template>
    <template #header-label="{ header, label, index }">
      <template v-if="header.key == 'action'">
      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
      Tindakan
      </template>
      <template v-else>
      {{ label }}
      </template>
      
    </template>
    <template #item-cell.status_lebel="{item, label, header, index}">
      <w-flex class="flex justify-center">
         <w-tag class="mr4" bg-color="error" round v-if="item.status==2||item.status==3">
           {{item.status_lebel}}
         </w-tag>
         <w-tag class="mr4" bg-color="success" round v-if="item.status==1">
           {{item.status_lebel}}
         </w-tag>
         <w-tag class="mr4" bg-color="warning" round v-if="item.status==4">
           {{item.status_lebel}}
         </w-tag>
         <w-tag class="mr4" bg-color="primary" round v-if="item.status==0" style="min-width: 80px; white-space: normal; height: auto;">
            {{item.status_lebel}}
         </w-tag>
      </w-flex>
    </template>

    <template #item-cell.action="{ item, label, header, index }">
      <w-flex class="flex justify-center">
         <template v-if="item.status != 3">
            <inertia-link :href="$route('administration.user.form',item.id)" bg-color="orange-light3" class="w-button orange--bg w-button--dark size--md  ml1"> 
               <w-icon xs class="mr2">fal fa-pencil</w-icon> KEMASKINI
            </inertia-link>
            &nbsp;  
           <template v-if="item.peranan != null">
           <w-button class="fs-2" bg-color="success-dark1" dark tile @click="sahkan(item)">
             <w-icon xs class="mr2">fal fa-check</w-icon> SAHKAN
           </w-button>
           &nbsp;  
           <w-button class="fs-2" bg-color="error-dark1" dark tile @click="tolak(item)">
             <w-icon xs class="mr2">fal fa-times</w-icon> TOLAK
           </w-button>
           </template>
           <template v-else>
            <!-- <w-button class="fs-2" bg-color="error-dark1" dark tile @click="destroy(item)">
             <w-icon xs class="mr2">fal fa-trash</w-icon> Padam
           </w-button> -->
           <w-button 
             bg-color="info-dark1" 
             dark
             tile
             :route="$route('administration.user.show',item.id)"
             class="be fs-2"
           >
             <w-icon xs class="mr2">fal fa-eye</w-icon> PAPAR 
           </w-button>
           </template>
        </template>
      </w-flex>
    </template>

  </z-table>
</div>
</div>
  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      isPassword: true,
      isPassword1: true,
      resourceurl: 'administration.user',
      jenis_pengguna:[],
      crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Pentadbiran', route: '/administration' },
        { label: 'Pengguna', route: '/administration/user' }
      ],
      form: {
        id: 0,
        name: '',
        email: '',
        jenis_pengguna_id: '',
        password_confirmation: '',
        password: '',
        lkp_cawangan_id:'',
      },
      dialog: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          item: {name: '', email: '', mobile: ''}
        },
      poskod : [],
      bandar : [],
      negeri : [],
      negara :  [],
      jenis_pengguna : [],
      mohon: [],
      peran: [],
      cawangan:[],
      pencarian: {
         role_id: '',
         status: '',
         lkp_negeri_id: '',
         name: '',
         email: '',
         no_id:'',
      }
    }
  },
  methods: {
      cari() {
         if(!this.valid) return;

         let params = {
         ...this.pencarian,
         };
         params.page = 1;
         params.per_page =9999;
         this.$inertia.visit(route(route().current(), params), {
             preserveState: true,
             preserveScroll: true,
         });
      },
      resetPencarian() {
         this.$inertia.visit(route(route().current()));
      },
      getCawangan(id){
         if(id == 2 || (id == 1 && this.form.lkp_negeri_id != '')){
            this.$zcomm.get(this.api_service + 'lookup/cawangan/'+this.form.lkp_negeri_id, {}).then(res => {
              this.cawangan = res
            })
         }else{
            this.$zcomm.get(this.api_service + 'lookup/cawangan/'+this.form.lkp_negeri_id, {}).then(res => {
              this.cawangan = res
            })
         }
      },
      getCapaian(id){
         this.$zcomm.get(this.api_service + 'lookup/capaian/0', {}).then(res => {
           this.peran = res
         })
      },
      getNegeri(){
          this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
            this.negeri = res
          })
      },

      getPeranan(id){
            this.$zcomm.get(this.api_service + 'lookup/peranan/'+this.form.lkp_jenis_pengguna_id, {}).then(res => {
              this.peran = res
            })
        },

      getlkpJenisPengguna(id){
            this.$zcomm.get(this.api_service + 'lookup/jenis_pengguna', {}).then(res => {
              this.jenis_pengguna = res
            })
        },

      getBandar(item){
            if (item == 2) {
              this.form.lkp_poskod_id = '';
              this.form.lkp_bandar_id = '';
            }
            if(item == 2 || (item == 1 && this.form.lkp_bandar_id != '')){
              this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.form.lkp_negeri_id, {}).then(res => {
              this.bandar = res
              })
            }
      },



      getPoskod(item){
          if (item == 2 || this.form.lkp_bandar_id == '') {
            this.form.lkp_poskod_id = '';
          }
          if(item == 2 || (item == 1 && this.form.lkp_bandar_id != '')){
            this.$zcomm.get(this.api_service + 'lookup/poskod/'+this.form.lkp_bandar_id, {}).then(res => {
              this.poskod = res
            })
          }else{
             this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.form.lkp_negeri_id, {}).then(res => {
             this.bandar = res
             })
           }
      },


      getPoskodUtama(){
            this.$zcomm.get(this.api_service + 'lookup/poskod_utama/'+this.form.kode, {}).then(res => {
              // this.form.p = res.p
              this.form.lkp_negeri_id = res.lkp_negeri_id
              this.form.lkp_bandar_id = res.lkp_bandar_id
              this.form.lkp_poskod_id = res.lkp_poskod_id
              this.getPoskod(0)
              this.getBandar(0)
              this.getCawangan(0);
            })
        },

      checkPoskod(){
          // alert(this.form.lkp_poskod_id);
          if(this.form.lkp_poskod_id == null){
            this.form.p = 0
          }
        },

      tambah() {
          this.form= {
                id: 0,
                name: null,
                email: null,
                // status: null,
                password: "",
                lkp_negeri_id: "",
                lkp_bandar_id: "",
                lkp_poskod_id: "",
                lkp_jenis_pengguna_id:"",

            };
          this.dialog.show = true
          this.getNegeri();
          this.getBandar(1);
          this.getPoskod(1);
          this.getlkpJenisPengguna();
          // $('#' + this.resourceurl).modal('show')
          this.form.saveButton = "Simpan"
      },
      edit1(idx) {
          this.form = idx;
          this.form.kode = idx.kode;
          this.form.saveButton = "Kemaskini";
          this.getNegeri();
          this.getBandar(1);
          this.getPoskod(1);
          this.getCawangan(1);
          this.getlkpJenisPengguna();
          this.dialog.show = true
      },
      sahkan(item) {
        this.loading = true;
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
        if (result.value) {
          if(item.id > 0){
          item.sahkan = 1;
          this.$zcomm.update(this.resourceurl + '.update', item.id, item)
              .then(res => {
                console.log(res);
                  this.dialog.show = false;
                  this.$inertia.visit(this.$route('administration.user.index'));
                  // this.$inertia.reload();
              })
              .catch(err => {

              })
              .finally(() => {
                  this.dialog.show = false
                  this.$inertia.visit(this.$route('administration.user.index'));
                  // this.$inertia.reload();
              });
              this.dialog.loading = false;
          }
        }else{ this.loading = false;}

        }) 
      },
      
      tolak(item) {
        this.loading = true;
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
        if (result.value) {
          if(item.id > 0){
          item.tolak = 1;
          this.$zcomm.update(this.resourceurl + '.update', item.id, item)
              .then(res => {
                console.log(res);
                  this.dialog.show = false;
                  this.$inertia.visit(this.$route('administration.user.index'));
                  // this.$inertia.reload();
              })
              .catch(err => {

              })
              .finally(() => {
                  this.dialog.show = false
                  this.$inertia.visit(this.$route('administration.user.index'));
                  // this.$inertia.reload();
              });
              this.dialog.loading = false;
          }
        }else{ this.loading = false;}

        }) 
      },
  
      submit1() {
          // if (this.$refs.form.validate()) {
              this.dialog.loading = true
              if (this.form.id > 0) {
                  this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                      .then(res => {
                        console.log(res);
                          //update displayed record
                          this.dialog.show = false;
                          this.$inertia.reload();
                      })
                      .catch(err => {
                        if (err.response.data.errors.email == "The email has already been taken.")
                            {
                                this.email_wujud = "Emel sudah wujud";
                            }
                        if (err.response.data.errors.no_id == "The no id has already been taken.")
                            {
                                this.no_id_wujud = "No id sudah wujud";
                            }

                      })
                      .finally(() => {
                          this.dialog.loading = false
                          this.dialog.show = false
                          this.$inertia.reload();
                      });
                      this.dialog.loading = false;
              }else {
                  this.$zcomm.add(this.resourceurl + '.store', this.form)
                      .then(res => {
                        console.log(res)
                        this.dialog.show = false;
                        this.$inertia.reload();
                      
                      })
                      .catch(err => {
                        if (err.response.data.errors.email == "The email has already been taken.")
                            {
                                this.email_wujud = "Emel sudah wujud";
                            }
                        if (err.response.data.errors.no_id == "The no id has already been taken.")
                            {
                                this.no_id_wujud = "No id sudah wujud";
                            }

                      })
                      .finally(() => {
                          this.dialog.loading = false;
                          // this.dialog.show = false
                          // this.$inertia.reload();

                        // $('#' + this.resourceurl).modal('hide')
                      });
                      this.dialog.loading = false;
              }
              this.dialog.loading = false;
          // }else{

          // }
      },
      destroy(idx) {
          this.form.id = idx.id
          if (confirm('Adakah anda pasti untuk memadam rekod ini?')) {
              this.$zcomm.delete(this.resourceurl + '.destroy', this.form.id)
                  .then(res => {
                    //update displayed record
                    this.sending = false;
                    this.dialog.show = false;
                    this.$inertia.visit(this.$page.url)
                    this.removeitem(res) // remove the data from list. no need to refresh page
                    if (typeof this.onAfterDelete === "function") {
                      this.onAfterDelete()
                    }
                  })
                  .finally(() => {
                    // $('#' + this.resourceurl).modal('hide')
                  });
          }
      },
    
  },
  watch: {

  },
  mounted() {
   this.getCapaian();
   this.getNegeri();
          // this.getNegeri();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>

<style>
.table-bar-search {
    padding: 0px 10px 10px 10px;
}
</style>
